import { get } from 'lodash';
import { useConstructorContextState } from './useConstructorContextState';

import { WidgetName } from '../../../models';

export const useGetWidgetName = (): WidgetName | undefined => {
  const state = useConstructorContextState();

  return get(state, ['widgetName']);
};
